"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let MRentalGeneralDataEditor = class MRentalGeneralDataEditor extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "modal",
    };
    beforeCreate() {
    }
    rental;
    onRental(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("rental");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    ux;
    dataMembers = ['formId', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                formId: null,
                ux: null,
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("Rental", "Edit General Information"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_9388_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeModal_9394_getActionArgs($event) {
        return {
            result: {
                ok: true,
                value: $event.data,
            },
        };
    }
    async act_1040167445267876_crud_9392_getActionArgs($event) {
        return {
            objectType: "rental",
            op: "upsert",
            data: this.rental,
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async act_1419464017721962_closeComponent_9396_getActionArgs($event) {
        return {
            result: {
                cancel: true,
            },
        };
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_9388 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_9388_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_9387 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_9388,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_9387],
        });
        const act_2248226175642056_closeComponent_9390 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_9389 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_9390,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_9389],
        });
        const act_1040167445267876_closeModal_9394 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1040167445267876_closeModal_9394_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_9393 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeModal_9394,
            event: "success",
            displayName: "closeModal",
        });
        const act_1040167445267876_crud_9392 = new core_1.actions.CRUDAction({
            actionArgs: this.act_1040167445267876_crud_9392_getActionArgs,
            displayName: "save",
            events: [evh_1040167445267876_success_9393],
        });
        const evh_1040167445267876_submit_9391 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_crud_9392,
            event: "submit",
            displayName: "save",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_9391],
        });
        const act_1419464017721962_closeComponent_9396 = new core_1.actions.CloseComponentAction({
            actionArgs: this.act_1419464017721962_closeComponent_9396_getActionArgs,
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_9395 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeComponent_9396,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_9395],
        });
        return {
            act_7315092382398562_closeModal_9388,
            evh_7315092382398562_close_9387,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_9390,
            evh_2248226175642056_close_9389,
            evh_2248226175642056_close,
            act_1040167445267876_closeModal_9394,
            evh_1040167445267876_success_9393,
            act_1040167445267876_crud_9392,
            evh_1040167445267876_submit_9391,
            evh_1040167445267876_submit,
            act_1419464017721962_closeComponent_9396,
            evh_1419464017721962_clickPreventStop_9395,
            evh_1419464017721962_clickPreventStop,
            save: act_1040167445267876_crud_9392,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], MRentalGeneralDataEditor.prototype, "rental", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('rental'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], MRentalGeneralDataEditor.prototype, "onRental", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], MRentalGeneralDataEditor.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], MRentalGeneralDataEditor.prototype, "onSize", null);
MRentalGeneralDataEditor = __decorate([
    (0, vue_property_decorator_1.Component)()
], MRentalGeneralDataEditor);
exports.default = MRentalGeneralDataEditor;
vue_property_decorator_1.Vue.component("MRentalGeneralDataEditor", MRentalGeneralDataEditor);
